import { render, staticRenderFns } from "./addVersion.vue?vue&type=template&id=09a8c98a&scoped=true"
import script from "./addVersion.vue?vue&type=script&lang=js"
export * from "./addVersion.vue?vue&type=script&lang=js"
import style0 from "./addVersion.vue?vue&type=style&index=0&id=09a8c98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a8c98a",
  null
  
)

export default component.exports